import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="state state--empty" style={{ minHeight: '60vh' }}>
      <div className="state__title" style={{ fontSize: '2.5rem' }}>
        404
      </div>
      <div className="state__detail">This page could not be found.</div>
      <Link className="btn btn--primary" to="/">
        Back to dashboard
      </Link>
    </div>
  );
}
